export const onlyOnePurchaseButtonVisible = () => {
    // Obtener los elementos
    const stickyPurchaseBtn = document.getElementById('sticky_purchase_btn');
    const productDataPurchaseBtn = document.getElementById('Product_data_purchase_btn');

    // Agregar un evento de escucha de desplazamiento en la ventana
    window.addEventListener('scroll', () => {
    // Obtener la posición del elemento en relación con la ventana
    const rect = productDataPurchaseBtn.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

    // Ocultar o mostrar el botón de compra
    if (isVisible) {
        stickyPurchaseBtn.style.display = 'none';
    } else {
        stickyPurchaseBtn.style.display = 'block';
    }
    });
}